module.exports = __webpack_public_path__ + "img/42.59ec2a89.jpg";